import templateUrl from "emun.order/order-list.htm";

export default () => ({
  templateUrl
});
